import { PermissionKey, UserRole } from '../enums';
import { DomainError } from '../errors/domain-error';
import { hasPermission } from '../rbac';

export function authorizeLike(role: UserRole): void {
  if (!hasPermission(role, PermissionKey.CAN_LIKE)) {
    throw new DomainError('Cannot like posts');
  }
}

export function authorizeComment(role: UserRole): void {
  if (!hasPermission(role, PermissionKey.CAN_COMMENT)) {
    throw new DomainError('Cannot comment on posts');
  }
}

export function authorizeBookmark(role: UserRole): void {
  if (!hasPermission(role, PermissionKey.CAN_BOOKMARK)) {
    throw new DomainError('Cannot bookmark posts');
  }
}

export function authorizeReport(role: UserRole): void {
  if (!hasPermission(role, PermissionKey.CAN_REPORT)) {
    throw new DomainError('Cannot submit reports');
  }
}
